package one.healthium.insights.domain.models

import one.healthium.insights.domain.content.ContentOptions

data class SavedContentOptions(
    val contentOptions: ContentOptions,
    val contentPreview: ContentPreviewModel,
)
